import { openapi } from '@scalar/openapi-parser'

import { Command } from 'commander'
import as from 'ansis'
import fs from 'node:fs'

import { output } from '@/helpers/std-out'
import { isUrl } from '@/domains/document/helpers'
import { getFileOrUrl } from '@/domains/document/helpers'
import { isYamlFileName } from '@/domains/document/helpers'

export function FormatCommand() {
  const cmd = new Command('format')

  cmd.description('Format an OpenAPI file')
  cmd.argument('[file|url]', 'File or URL to format')
  cmd.option('-o, --output <file>', 'Output file')
  cmd.action(
    async (
      inputArgument: string,
      { output: outputPath }: { output?: string },
    ) => {
      const startTime = performance.now()

      if (!inputArgument) {
        return output
          .error()
          .title('Invalid argument')
          .message('Please provide a file path')
          .exit('error')
      }
      const specification = await getFileOrUrl(inputArgument)

      const newContent = isYamlFileName(outputPath || inputArgument)
        ? await openapi().load(specification).toYaml()
        : await openapi().load(specification).toJson()

      // Replace file content with newContent
      if (outputPath) {
        fs.writeFileSync(outputPath, newContent, 'utf8')
      } else if (!isUrl(inputArgument)) {
        fs.writeFileSync(inputArgument, newContent, 'utf8')
      } else {
        return output
          .error()
          .title('Invalid argument')
          .message()
          .message(
            'Output file is required for URLs. Try passing --output file flag.',
          )
          .exit('error')
      }

      const endTime = performance.now()

      output
        .info()
        .line(
          `${as.green('File formatted')} ${as.grey(
            `in ${as.white(`${as.bold(`${Math.round(endTime - startTime)}`)} ms`)}`,
          )}`,
        )
        .print()
    },
  )

  return cmd
}
